/* background images config */
game.config.bgImages = {
  defaultProvider: "pexels",
  providers: {
    "unsplash_simple": {
      url: "https://source.unsplash.com/random/"
    },
    "pexels": {

    },
    "none": {

    }
  }
};
